import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Col } from 'react-bootstrap';
import { find as _find, findIndex as _findIndex } from 'lodash';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import List from 'components/List';

import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';

class ItemStock extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['stock'];
  }

  getWarehouseStock = location => {
    const { entity } = this.props;
    const stock = _find(entity.getStock().getWarehouseStock(), ['id', location.id]);
    if (stock !== undefined) {
      return stock.getStock();
    }

    return '0';
  };

  stockChanged = (locationId, stock) => {
    const { entity, changeEntity } = this.props;
    let newWarehouseStock = entity.createValue('warehouseStock', ['stock'], {
      id: locationId,
      stock,
    });
    const index = _findIndex(entity.getStock().getWarehouseStock(), ['id', locationId]);

    let newEntity;
    if (index >= 0) {
      newEntity = { ...entity.updateValue(index + '', newWarehouseStock, ['stock', 'warehouseStock']) };
    } else {
      newEntity = { ...entity.updateValue('warehouseStock', [newWarehouseStock], ['stock']) };
    }

    changeEntity(newEntity);
  };

  render() {
    const {
      intl: { messages },
      entity,
      disabled,
      data,
    } = this.props;

    return (
      <Col xs={12} md={4}>
        <List noRender listName="companyLocations" url="/api/locations.json" list={data} />

        <div class="panel panel-transparent">
          <div class="panel-body">
            <p>
              {messages.stock_level} {data.pending && <i class="fa fa-circle-notch fa-spin" />}
            </p>
            {!data.pending && (
              <div>
                {entity.getType() === 'item' && (
                  <div class="m-b-15">
                    <FormSwitchery
                      name="isUnlimited"
                      checked={entity.getStock().getIsUnlimited()}
                      value
                      label={messages.always_available}
                      onChange={this.updateEntity}
                    />
                  </div>
                )}

                <div class="m-b-15">
                  <FormInput
                    type="number"
                    label={'Online stock'}
                    value={entity.getStock().getOnlineStock()}
                    name="onlineStock"
                    meta={entity.getStock().getOnlineStockMetaInformation()}
                    validation={entity.getStock().getOnlineStockValidationResult()}
                    onChange={this.updateEntity}
                    disabled={disabled}
                  />
                </div>

                <div class="form-group-attached">
                  {data.data.list.map((location, i) => {
                    if (location.is_warehouse) {
                      return (
                        <FormInput
                          key={i}
                          type="number"
                          label={location.name}
                          value={this.getWarehouseStock(location)}
                          name={location.id}
                          meta={entity.getStock().getWarehouseStockMetaInformation()}
                          validation={entity.getStock().getWarehouseStockValidationResult()}
                          onChange={this.stockChanged}
                          disabled={disabled}
                        />
                      );
                    }

                    return null;
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </Col>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.list.companyLocations,
  };
};

export default injectIntl(connect(mapStateToProps)(ItemStock));
